import { API_REQUEST_TYPES } from "../../enums";
import { resetApi } from "../../services/axios";
import { API } from "../endpoints";

export type Holiday = {
  _id?: string;
  name?: string;
  type: "ANNUAL" | "ONE_TIME";
  month?: number;
  day?: number;
  date?: string;
  year?: number;
  active?: boolean;
};

export type HolidaysListResponse = {
  success: boolean;
  data: Holiday[];
  total?: number;
  message?: string;
};

export function mapHolidaysToDateKeys(
  holidays: Holiday[],
  year: number
): string[] {
  const keys = new Set<string>();

  for (const holiday of holidays) {
    if (holiday.active === false) continue;

    if (holiday.type === "ONE_TIME" && holiday.date) {
      keys.add(holiday.date);
      continue;
    }

    if (holiday.month != null && holiday.day != null) {
      const month = String(holiday.month).padStart(2, "0");
      const day = String(holiday.day).padStart(2, "0");
      keys.add(`${year}-${month}-${day}`);
    }
  }

  return Array.from(keys);
}

export function getHolidays({ year }: { year: number }) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.HOLIDAYS.LIST({ year }),
        payload: {},
        config: {
          notifyError: false,
        },
      })
    );

    return res as HolidaysListResponse;
  };
}
